import Bullets from './Bullets';

export default Bullets;
